// /src/renderer/settings/tabs/tabContentMapping.ts
import GeneralSetting from './general';
import PACSConnectionSetting from './pacsConnection';
import AccountSetting from './account';
import JobQueueSetting from './jobqueue';
import SettingsSetting from './settings';
import { SETTING_TAB_NAMES } from 'config/labels';

export interface TabContentMappingProps {
  id: string;
  title: string;
  content: React.FC;
}

export const TAB_CONTENT_MAPPING: Record<string,TabContentMappingProps> = {
  general: { id: 'general', title: SETTING_TAB_NAMES.general, content:GeneralSetting },
  pacsConnection: {id: 'pacsConnection',title: SETTING_TAB_NAMES.pacsConnection,content:PACSConnectionSetting},
  account: { id: 'account', title: SETTING_TAB_NAMES.account,content:AccountSetting },
  jobqueue: { id: 'jobqueue', title: SETTING_TAB_NAMES.jobqueue,content:JobQueueSetting },
  settings: { id: 'settings', title: SETTING_TAB_NAMES.settings,content:SettingsSetting  },
};
